<form fxFlex fxLayout="column" name="searchForm">
  <div fxFlex="1 1 100" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="24px">
    @for (control of controls; track control) {
      <mat-form-field [ngClass]="'filters-field filters-field-' + control.field.id"
        [style.visibility]="control.field.hidden?'hidden':'visible'">
        <mat-label>{{control.field.label | translate}}</mat-label>
        @if (isFieldListOption(control.field)) {
          <mat-select
            [attr.id]="control.field.id"
            [attr.name]="control.field.id"
            [formControl]="control.formControl"
            [placeholder]="control.field.placeholder | translate">
            <mat-option value="all">{{ 'generic.all' | translate }}</mat-option>
            @for (item of control.field.list; track item) {
              <mat-option [value]="item.id">
                <span>{{ item.label | translate }}</span>
              </mat-option>
            }
          </mat-select>
        }
        @if (isFieldTextOption(control.field)) {
          <input
            [formControl]="control.formControl"
            [placeholder]="control.field.placeholder"
            matInput>
        }
      </mat-form-field>
      @if (control.field.showInfoIcon) {
        <mat-icon svgIcon="info"
        (click)="infoClick(control.field.id)"></mat-icon>
      }
    }

    <button (click)="onSearchButtonClick()" class="filters-field-launchSearch" color="primary"
    mat-raised-button>{{ 'generic.search' | translate }}</button>
  </div>
</form>
